module.exports = __webpack_public_path__ + "static/media/Wipro.f991a782.jpg";